import { RedirectCommand, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';

export function createAuthenticatedRedirectGuard(redirectUrl = '/') {
    return () => {
        const authenticationService = inject(AuthenticationService);
        const router = inject(Router);

        if (authenticationService.isAuthenticated()) {
            return new RedirectCommand(router.parseUrl(redirectUrl), { replaceUrl: true });
        }

        return true;
    };
}
